import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { ProfileService } from '../data-access/user.service';

export const adminGuard: CanMatchFn = () => inject(ProfileService).isAdmin();
